import { Link } from "react-router-dom";
import Footer from "../../Layouts/Footer";

const CookiesPolicy = () => {
  return (
    <>
      {/* <Header /> */}
      <div id="ajax-content-wrap">
        <div className="breadcrumb">
          <span>
            <span>
              <Link to="/">Home</Link> /{" "}
              <span className="breadcrumb_last" aria-current="page">
                Cookies Policy{" "}
              </span>
            </span>
          </span>{" "}
        </div>
        <div
          id="page-header-wrap"
          data-animate-in-effect="none"
          data-midnight="light"
          className=""
          style={{ height: "250px" }}
        >
          <div
            id="page-header-bg"
            className="not-loaded "
            data-padding-amt="low"
            data-animate-in-effect="none"
            data-midnight="light"
            data-text-effect="rotate_in"
            data-bg-pos="center"
            data-alignment="center"
            data-alignment-v="middle"
            data-parallax="0"
            data-height="250"
            style={{ backgroundColor: "#e8f5e5", height: "250px" }}
          >
            <div className="container">
              <div className="row">
                <div className="col span_6 ">
                  <div className="inner-wrap">
                    <h1 className="top-heading">
                      <span className="wraped">
                        <span
                          style={{
                            transform: "rotateX(0deg) translate(0px)",
                            opacity: 1,
                            color: "black",
                          }}
                        >
                          Cookie
                        </span>
                      </span>{" "}
                      <span className="wraped">
                        <span
                          style={{
                            transform: "rotateX(0deg) translate(0px)",
                            opacity: 1,
                            color: "black",
                          }}
                        >
                          Policy
                        </span>
                      </span>
                    </h1>{" "}
                    <span
                      className="subheader"
                      style={{
                        transform: "rotateX(0deg) translate(0px)",
                        opacity: 1,
                      }}
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-wrap" style={{ minHeight: "24px" }}>
          <div className="container main-content">
            <div className="row">
              <div
                id="fws_661203cfdde9f"
                data-column-margin="default"
                data-midnight="dark"
                className="wpb_row vc_row-fluid vc_row  vc_row-o-equal-height vc_row-flex   right_padding_85px left_padding_85px right_padding_tablet_65px right_padding_phone_20px left_padding_tablet_65px left_padding_phone_20px "
                style={{ paddingTop: "60px", paddingBottom: "0px" }}
              >
                <div
                  className="row-bg-wrap"
                  data-bg-animation="none"
                  data-bg-overlay="false"
                >
                  <div className="inner-wrap">
                    <div className="row-bg" style={{}}></div>
                  </div>
                </div>
                <div className="row_col_wrap_12 col span_12 dark left">
                  <div
                    className="vc_col-sm-12 wpb_column column_container vc_column_container col no-extra-padding inherit_tablet inherit_phone "
                    data-padding-pos="all"
                    data-has-bg-color="false"
                    data-bg-color=""
                    data-bg-opacity="1"
                    data-animation=""
                    data-delay="0"
                  >
                    <div className="vc_column-inner">
                      <div className="wpb_wrapper">
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p>
                              <span style={{ color: "#000000" }}>
                                Please read the following carefully to
                                understand our policies and practices regarding
                                your personal information and how we will treat
                                it. By using or accessing our website, you agree
                                to this privacy policy. This policy may change
                                from time to time and your continued use of our
                                website is deemed to be acceptance of such
                                changes, so please check the policy periodically
                                for updates.
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p>
                              <span style={{ color: "#000000" }}>
                                <strong>1. ABOUT COOKIES</strong>
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "#000000" }}>
                                A cookie is a small text file containing a
                                unique identification number that is placed on
                                the hard disk of your computer by a web page
                                server, enabling the web server to identify your
                                web browser and passively track its activities
                                on that website. A cookie does not reveal any
                                personally identifiable information that you
                                have not otherwise disclosed. Cookies do not
                                contain any executable code and cannot be used
                                for infecting your computer with a virus. Most
                                Web browsers automatically accept cookies but
                                usually provide the option of configuring your
                                browser to accept all cookies, reject all
                                cookies, or notify you when a cookie is sent.
                                You can change your settings in the preferences
                                or options menu of your browser. If you choose
                                to decline cookies, certain features of our site
                                may not be available to you.
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p>
                              <span style={{ color: "#000000" }}>
                                <strong>
                                  2. HOW DOES LAPOTENCIELLE, LLC USE COOKIES?
                                </strong>
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "#000000" }}>
                                2.1 In line with standard industry practice, we
                                use cookies to track site usage. We use cookies
                                that are strictly necessary to enable/allow you
                                to move around our site. LapOtencielle, LLC also
                                uses cookies to improve your experience by
                                remembering your details so that you do not need
                                to keep re-entering them when navigating our
                                website.
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "#000000" }}>
                                2.2 One of the reasons this website uses cookies
                                is to make sure that people are not counted
                                double. This analytics cookie does not store any
                                personal details like your name or email
                                address. It’s just there to help us find out
                                what’s popular among website visitors.
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p>
                              <span style={{ color: "#000000" }}>
                                <strong>
                                  3. COOKIES THAT LAPOTENCIELLE, LLC USES
                                </strong>
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "#000000" }}>
                                3.1 LapOtencielle, LLC uses a few services to
                                help us understand how people use our website
                                and the problems they might encounter as they
                                use it.
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "#000000" }}>
                                3.1.1. Google Analytics: We use Google Analytics
                                (which uses cookies) to help us understand what
                                actions people take when they are using the
                                website, and&nbsp;information about the device
                                the user is using to access the website. All of
                                the data we track in Google Analytics is
                                anonymous and there is no personal identifying
                                information contained therein. To opt out of our
                                usage of Google Analytics, you can use this
                                opt-out tool from Google. Google has more
                                information about the cookies they use and how
                                you can be aware of what’s being tracked.
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "#000000" }}>
                                3.2 LapOtencielle, LLC uses cookies for the
                                following purposes:
                              </span>
                              <br />
                              <span style={{ color: "#000000" }}>
                                (a) Authentication – we use cookies to identify
                                you when you visit our website and as you
                                navigate our website;
                              </span>
                              <br />
                              <span style={{ color: "#000000" }}>
                                (b) Status – we use cookies to help us to
                                determine if you are logged into our website;
                              </span>
                              <br />
                              <span style={{ color: "#000000" }}>
                                (c) Personalization – we use cookies to store
                                information about your preferences and to
                                personalize the website for you;
                              </span>
                              <br />
                              <span style={{ color: "#000000" }}>
                                (d) Security – we use cookies as an element of
                                the security measures used to protect users.
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p>
                              <span style={{ color: "#000000" }}>
                                <strong>4. HOW TO DELETE COOKIES</strong>
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "#000000" }}>
                                You can control your cookies, delete them and
                                reject them in the settings of your browser.
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p>
                              <span style={{ color: "#000000" }}>
                                <strong>5. ACCEPTANCE</strong>
                              </span>
                              <br />
                              <span style={{ color: "#000000" }}>
                                Your access to and use of LapOtencielle, LLC is
                                conditioned on your acceptance of and compliance
                                with these Cookie Policy. These Terms apply to
                                all visitors, users and others who access or use
                                the website. By using the website and agreeing
                                to this policy, you consent to our use of
                                cookies in accordance with the terms given
                                herein.
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
        {/* Footer  */}
      </div>
    </>
  );
};

export default CookiesPolicy;
